module.exports = __webpack_public_path__ + "img/redpoint-logo.b12ac11.svg";